import { environment } from "./../../../../../environments/environment";
import { Component, OnInit, Compiler } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "src/service/http.service";
import { GlobalcfgService } from "src/service/globalcfg.service";
import Swal from "sweetalert2";
import * as CryptoJS from "crypto-js";

import { AuthGuard } from "src/app/guards/auth.guard";
@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.css"],
})
export class SignInComponent implements OnInit {
  model: any = {};
  fieldTextType: boolean;
  isCollapsed = true;
  roleObj: any = [];
  tokenFromUI: string = "17eba9787a50e18b23d3";
  encrypted: any = "";
  id: any;
  request: string;
  constructor(
    private router: Router,
    private httpService: HttpService,
    private globalcfgService: GlobalcfgService,
    private _Activatedroute: ActivatedRoute,
    private authGuard: AuthGuard,
    private _compiler: Compiler
  ) {
    //  this.authGuard.checkIdStatus();
  }
  // dummyData:any;
  ngOnInit(): void {
    localStorage.clear();
    this._compiler.clearCache();
    let ciphertext = CryptoJS.AES.encrypt("12345", this.tokenFromUI).toString();
    console.log(ciphertext);

    this.httpService.getIPAddress().subscribe((data: any) => {
      
      localStorage.setItem('IP' ,data.ip )
    });


  }
  /*onValueChange(event){
    console.log(event);
    let  data = this.totalTableData;
    let  data1 = this.totalTableData1;

    if(event.target.value === '10k'){
      data.filter(val=>{
        if(val.kolCount <= 10000){
          val.kolCount = 0;
        }
      })
      this.dummyData = data;
    }else {
      data1.forEach(val=>{
        if(val.kolCount > 20000){
          
        }else {
          val.kolCount  = 0
        }
      })
      this.dummyData = data1;
    }
    console.log(this.dummyData);

   
  }*/

  onSignIn(form: NgForm) {
    if (form.valid) {
      let _key = CryptoJS.enc.Utf8.parse(form.value.password);
      let _iv = CryptoJS.enc.Utf8.parse(form.value.password);
    
      const timestamp = Date.now();
      // timestamp in secondsconsole.log(Math.floor(timestamp/1000));

      
      var userObj = {
        email: form.value.email,
        password: form.value.password,
        timestamp: Math.floor(timestamp / 1000),
      };
      let ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(userObj),
        this.tokenFromUI
      ).toString();
      this.httpService.userLogin(ciphertext).subscribe(
        (result) => {
          if (result["responseCode"] === 0) {
            localStorage.setItem("email", result.responseData.email);
            localStorage.setItem("authToken", result.responseData.token);

            if (result.responseData.user_verify == 0) {
              localStorage.setItem("uuid", result.responseData.user_id);
              this.router.navigate(["reset-password"]);
            } else {
               
              this.httpService.loginOTP({
                email: form.value.email
              }).subscribe(
                (response) => {
                  Swal.fire({
                    html: `<h6 class="head">Please enter the OTP send to your Email<h6><h5 class="sub-head">${form.value.email}</h5>`,
                    icon: "success",

                    confirmButtonText: "OK",
                    customClass: {
                      container: "my-swal",
                      confirmButton: "your-confirm-button-class",
                    },
                  }).then((results) => {
                    localStorage.setItem(
                      "token",
                      response.responseData.otp_tokenId
                    );

                    this.router.navigate(["otp"]);
                  });
                },
                (error) => {
                  console.log(error);
                }
              );
            }
          } else {
            Swal.fire({
              html: `<h6 class="head">Error!<h6><h5 class="sub-head">${result["responseData"]}</h5>`,
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                container: "my-swal",
                confirmButton: "your-confirm-button-class",
              },
            }).then((result) => {});
          }

          /* if (Number(result.success) == 1) {
           
            if (result.responseData[0][0].user_verify == 0) {
              localStorage.setItem("uuid", result.data[0].user_id);
              this.router.navigate(["change-password"]);
            } else {
              this.httpService.loginOTP(userObj).subscribe(
                (response) => {
                  Swal.fire({
                    html: `<h6 class="head">Please enter the OTP send to your Email<h6><h5 class="sub-head">${form.value.email}</h5>`,
                    icon: "success",

                    confirmButtonText: "OK",
                    customClass: {
                      container: "my-swal",
                      confirmButton: "your-confirm-button-class",
                    },
                  }).then((results) => {
                    localStorage.setItem(
                      "token",
                      response.Response.otp_tokenId
                    );

                    this.router.navigate(["otp"]);
                  });
                },
                (error) => {
                  console.log(error);
                }
              );
            }
          } else {
            Swal.fire({
              html: `<h6 class="head">Error!<h6><h5 class="sub-head">Bad Credentials</h5>`,
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                container: "my-swal",
                confirmButton: "your-confirm-button-class",
              },
            }).then((result) => {});
          }*/
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  goToSignUp() {
    this.router.navigate(["/"]);
  }
}
